import _ from 'lodash';

const $discount = $('.js-discount');
const $input = $('.js-discount-input');
const $trigger = $('.js-discount-trigger');
const $content = $('.js-discount-content');
const $couponStatus = $('.js-coupon-status');

const discount = {
  initialize() {
    if ($discount.length) {
      this.createListeners();
    }
  },

  createListeners() {
    const debouncedCouponValidation = _.debounce(this.validateCoupon.bind(this), 300);

    $input.on('keyup', debouncedCouponValidation);

    if ($input.val() !== '') {
      $content.show();
      $trigger.hide();
    }

    $trigger.on('click', () => {
      $content.show();
      $input.focus();
    });
  },

  validateCoupon() {
    $couponStatus.hide();

    $.ajax({
      method: 'GET',
      url: `/api/coupon/${$input.val()}`,
      processData: false,
      contentType: false,
    }).then(() => {
      window.location.reload();
    });
  },
};

export default discount;
